"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAggregatedAppDeploymentLogs = void 0;
const getAggregatedAppDeploymentLogs = ({ httpClient, }) => ({ app_id, component_name, deployment_id, follow, pod_connection_timeout, type, }) => {
    const path = '/apps';
    const url = `${path}/${app_id}/deployments/${deployment_id}/logs`;
    const query_params = { component_name, follow, pod_connection_timeout, type };
    return httpClient.get(url, { params: query_params });
};
exports.getAggregatedAppDeploymentLogs = getAggregatedAppDeploymentLogs;
//# sourceMappingURL=get-aggregated-app-deployment-logs.js.map